import { isObject } from "./conversion";

export function getPropOrArrayElement(obj: any, prop: string) {
	// prop could be e.g. "name", or ref to array element "cols[0]"
	let arrIndex;

	if (prop.endsWith("]")) {
		const i = prop.lastIndexOf("[");
		arrIndex = prop.substring(i+1, prop.length-1);
		prop = prop.substring(0, i);
	}

	let result = obj[prop];
	if (arrIndex !== undefined) {
		result = result[arrIndex];
	}

	return result;
}

export function getObjectValue(obj: any, prop: string) {
	if (prop.indexOf(".") > 0) {
		const parts = prop.split(".");
		let o: any = obj;
		for(let p of parts) {
			o = getPropOrArrayElement(o, p);
			if (o === undefined || o === null) return o;
		}
		return o;
	} else {
		return getPropOrArrayElement(obj, prop);
	}
}


interface PropInfo {
	arrayIndex?: number,
	name: string,
}

// find first occurence
export function getFirstObjectValue(obj: any, prop: string): any {

	function find(within: any, prop: PropInfo): any {
	
		const keys = Object.keys(within);

		// does the key exist within this object?
		if (keys.indexOf(prop.name) >= 0) {
			// check that its an array when it should be 
			const v = within[prop.name];
			if ((prop.arrayIndex !== undefined) && Array.isArray(v)) {
				return v[prop.arrayIndex];
			} else if (!prop.arrayIndex) {
				return v;
			}
		}

		// else keep looking through all props 
		for(let k of keys) {
			const v = within[k];
			if (Array.isArray(v)) {
				const a = v as any[];
				for(let item of a) {
					if (isObject(item)) {
						const result = find(item, prop);
						if (result !== undefined) return result;			
					}
				}

			} else if (isObject(v)) {
				const result = find(v, prop);
				if (result !== undefined) return result;	
			}
		}

		return undefined;
	}

	function parseProp(prop: string) {
		let arrayIndex;
		let name = prop;

		if (name.endsWith("]")) {
			const i = name.lastIndexOf("[");
			arrayIndex = Number(name.substring(i+1, prop.length-1));
			name = name.substring(0, i);
		}

		return {
			name,
			arrayIndex,
		};
	}

	const parts = prop.split(".");
	if (parts.length === 1) {
		const propInfo = parseProp(parts[0]);
		return find(obj, propInfo)

	} else {
		// find the first part
		const propInfo = parseProp(parts[0]);
		const start = find(obj, propInfo);
		if (!start) return undefined;

		// now expect exact match from this point on
		parts.splice(0, 1);
		return getObjectValue(start, parts.join("."));
	}

}

export function setObjectValue(obj: any, prop: string, value: any) {
	if (prop.indexOf(".") > 0) {
		const parts = prop.split(".");
		let o: any = obj ? obj : {};

		// NOTE: nav to 2nd last part (the parent)
		for(let i=0;i<parts.length-1;i++) {
			const p = parts[i];
			
			const tmp = getPropOrArrayElement(o, p);
			if (tmp === undefined || tmp === null) {
				const newObj = {};
				o[p] = newObj;
				o = newObj;
			} else {
				o = tmp;
			}
		}
		// now set value
		o[parts[parts.length-1]] = value;
	} else {
		obj[prop] = value;
	}
}

export function getLastProp(path: string): string | undefined {
    if (path.indexOf(".") > 0) {
        var keys = path.split('.');
        return (keys.length > 0) ? keys[keys.length-1] : undefined;
    } else {
        return path;
    }
}

// export function traverse(obj: any, path: string, newValue?: { val: any }): any {
//     if (!obj) return null;
// debugger;
//     var keys = path.split('.');

//     const isSettingValue = (typeof newValue !== "undefined");

//     for (var i = 0; i < keys.length; i++) {
//         var key = keys[i];
//         var arrIndex = -1;
//         const isLast = (i === (keys.length-1));

//         const j = key.indexOf("[");
//         if (j > 0) {
//             // array
//             arrIndex = parseInt(key.substr(j+1, key.length-j-2));
//             key = key.substr(0, j);
//         }

//         if (!obj.hasOwnProperty(key)) {
//             // if we are setting value then auto create the value
//             if (typeof newValue !== "undefined") {
//                 obj[key] = newValue.val;
//                 return obj[key];
//             } else {
//                 return null;
//             }
//         }

//         if (arrIndex >= 0) {
//             obj = obj[key];
//             if (obj.length && arrIndex >= 0 && arrIndex < obj.length) {
//                 if (isLast && isSettingValue) {
//                     obj[arrIndex] = newValue.val;
//                 } else {
//                     obj = obj[arrIndex];
//                 }
//             } else {
//                 return null;
//             }
//         } else {
//             if (isLast && isSettingValue) {
//                 obj[key] = newValue.val;
//             } else {
//                 obj = obj[key];
//             }
//         }
//     }

//     return obj;
// }
